import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CookiePolicyPage = ({ language }) => {
  const isRo = language === 'ro';
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#faf9f7] py-24 sm:py-32">
      <div className="container mx-auto px-6 sm:px-8 lg:px-12 max-w-4xl">
        <button 
          onClick={() => navigate('/')}
          className="flex items-center text-[#334d6e] hover:text-[#0D1B3E] font-body text-sm mb-8 transition-colors"
        >
          <ArrowLeft size={18} className="mr-2" />
          {isRo ? 'Înapoi la pagina principală' : 'Back to Home'}
        </button>

        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0D1B3E] mb-12">
          {isRo ? 'Politica de Cookie-uri' : 'Cookie Policy'}
        </h1>

        <div className="prose prose-lg max-w-none font-body text-[#334d6e] space-y-8">
          <p className="text-sm" data-testid="cookie-last-updated">{isRo ? 'Ultima actualizare' : 'Last updated'}: 08.10.2026</p>

          <section data-testid="cookie-operator">
            <h2 className="font-display text-xl text-[#0D1B3E] mt-8 mb-4">
              {isRo ? 'Operatorul Site-ului' : 'Website Operator'}
            </h2>
            <p><strong>Quantive Endeavors SRL</strong><br />
            Str. Avram Iancu nr. 56, ap. 2, Brașov<br />
            CUI 54042200<br />
            Email: contact@montreon.ro</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0D1B3E] mt-8 mb-4">
              1. {isRo ? 'Ce Sunt Cookie-urile' : 'What Are Cookies'}
            </h2>
            <p>{isRo 
              ? 'Cookie-urile sunt fișiere text mici stocate pe dispozitivul dumneavoastră când vizitați un site web.' 
              : 'Cookies are small text files stored on your device when visiting a website.'}</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0D1B3E] mt-8 mb-4">
              2. {isRo ? 'Tipuri de Cookie-uri pe Care le Folosim' : 'Types of Cookies We Use'}
            </h2>
            
            <h3 className="font-display text-lg text-[#0D1B3E] mt-6 mb-3">
              {isRo ? 'Cookie-uri Esențiale' : 'Essential Cookies'}
            </h3>
            <p>{isRo 
              ? 'Necesare pentru funcționalitatea site-ului (rezervări, securitate, navigare).' 
              : 'Required for website functionality (booking, security, navigation).'}</p>
            
            <h3 className="font-display text-lg text-[#0D1B3E] mt-6 mb-3">
              {isRo ? 'Cookie-uri de Analiză' : 'Analytics Cookies'}
            </h3>
            <p>{isRo 
              ? 'Folosite pentru a analiza traficul și a îmbunătăți performanța site-ului.' 
              : 'Used to analyze traffic and improve website performance.'}</p>
            
            <h3 className="font-display text-lg text-[#0D1B3E] mt-6 mb-3">
              {isRo ? 'Cookie-uri de Marketing' : 'Marketing Cookies'}
            </h3>
            <p>{isRo 
              ? 'Folosite pentru publicitate și remarketing.' 
              : 'Used for advertising and remarketing purposes.'}</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0D1B3E] mt-8 mb-4">
              3. {isRo ? 'Gestionarea Cookie-urilor' : 'Managing Cookies'}
            </h2>
            <p>{isRo 
              ? 'Puteți gestiona sau dezactiva cookie-urile prin setările browserului dumneavoastră.' 
              : 'You can manage or disable cookies through your browser settings.'}</p>
            <p>{isRo 
              ? 'Dezactivarea cookie-urilor esențiale poate afecta funcționalitatea site-ului.' 
              : 'Disabling essential cookies may affect website functionality.'}</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0D1B3E] mt-8 mb-4">
              4. {isRo ? 'Cookie-uri de la Terți' : 'Third-Party Cookies'}
            </h2>
            <p>{isRo ? 'Putem folosi servicii precum:' : 'We may use services such as:'}</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Google Analytics</li>
              <li>Google Ads</li>
              <li>Meta (Facebook) Pixel</li>
            </ul>
            <p>{isRo 
              ? 'Acești furnizori pot procesa date conform propriilor politici de confidențialitate.' 
              : 'These providers may process data according to their own privacy policies.'}</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0D1B3E] mt-8 mb-4">
              5. {isRo ? 'Consimțământ' : 'Consent'}
            </h2>
            <p>{isRo 
              ? 'Prin continuarea utilizării site-ului, consimțiți la utilizarea cookie-urilor conform descrierii.' 
              : 'By continuing to use the website, you consent to the use of cookies as described.'}</p>
            <p>{isRo 
              ? 'Puteți retrage consimțământul oricând prin setările browserului.' 
              : 'You may withdraw consent at any time via browser settings.'}</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
